export default class FrameBaseManager {
  constructor() {
    this.frame = null;
  }

  setFrame(frame) {
    this.frame = frame;
  }

  setShapeToLayer(id, shape) {
    const layer = this.frame.layers.find((layer) => layer.id === id);
    layer.shape = shape;
  }

  setPointsToLayer(id, points) {
    const layer = this.frame.layers.find((layer) => layer.id === id);
    layer.points = points;
  }
}
